import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface BrandLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  linkTo?: string;
}

const sizeClasses = {
  sm: 'h-6 w-auto',
  md: 'h-8 w-auto', 
  lg: 'h-10 w-auto',
  xl: 'h-12 w-auto'
};

const textSizeClasses = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl'
};

export const BrandLogo: React.FC<BrandLogoProps> = ({ 
  size = 'md',
  showText = true,
  className,
  linkTo = '/'
}) => {
  const logoContent = (
    <div id="brand-logo-container" className={cn('flex items-center space-x-3 hover:opacity-90 transition-opacity', className)}>
      <img 
        id="brand-logo-image"
        src="/logos/ChatsLyticsLogoRBG.png" 
        alt="Chatslytics Logo"
        className={cn('object-contain', sizeClasses[size])}
        onError={(e) => {
          // Enhanced fallback with brand gradient styling
          const target = e.target as HTMLImageElement;
          target.style.display = 'none';
          const parent = target.parentElement;
          if (parent) {
            const fallbackDiv = document.createElement('div');
            fallbackDiv.className = `${sizeClasses[size].replace('w-auto', `w-${size === 'sm' ? '6' : size === 'md' ? '8' : size === 'lg' ? '10' : '12'}`)} bg-gradient-brand rounded-lg flex items-center justify-center shadow-brand`;
            fallbackDiv.innerHTML = `<span class=\"text-white font-bold ${textSizeClasses[size]}\">C</span>`;
            parent.insertBefore(fallbackDiv, target);
          }
        }}
      />
      {showText && (
        <div id="brand-logo-text" className={cn('hidden font-heading font-bold sm:flex flex-col text-foreground', textSizeClasses[size])}>
          <span id="brand-logo-text-chatslytics" className="text-brand-purple leading-tight">Chatslytics</span>
          <span id="brand-logo-text-agent-builder" className="text-brand-orange leading-tight">Agent Builder</span>
        </div>
      )}
    </div>
  );

  if (linkTo) {
    return <Link to={linkTo}>{logoContent}</Link>;
  }

  return logoContent;
};
